/**
 * GET /v1/schools/:school_id/config/menus — the school's navigation menus
 * (drawer, tabs and the home widget), as the mobile app reads them.
 */

import { z } from 'zod'
import { NavigationStructureSchema } from '../../schemas'

export const GetSchoolMenusResponseSchema = z.object({
  data: NavigationStructureSchema,
  message: z.string()
})
export type GetSchoolMenusResponse = z.infer<typeof GetSchoolMenusResponseSchema>
